<template>
  <div class="background_index_news">
    <div style="height: 92vh">
      <div style="padding-top: 25vh">
        <p style="font-size: 22px">我们的优势</p>
        <p>———</p>
        <p style="font-size: 24px;margin-bottom: 0">感念际遇 不生苦毒 </p>
        <p style="font-size: 24px">尊重对手 战胜自己</p>
        <p style="font-size: 12px">十余年来，海纳亚洲主要聚焦投资科技、传媒、</p>
        <p style="font-size: 12px">消费品、现代服务、医疗、环保等领域。</p>
      </div>
      <div style="margin-top: 2vh">
        <a-button type="ghost">
          <router-link :to="'/news_m'" @click.passive="backtotop">查看更多公司新闻</router-link>
        </a-button>
      </div>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/";

export default {
  name: 'Index_news_m',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    return {next_page, backtotop}
  }
}

</script>
<style scoped>
.background_index_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;

  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>